import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/nominas/salario-base-de-cotizacion-variable-detalle/';

/**
 * GET SBCDetalles
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getSBCDetalles = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET SBCDetalles
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getSBCDetallesParams = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET SBCDetalle
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getSBCDetalle = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST SBCDetalle
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postSBCDetalle = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH SBCDetalle
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchSBCDetalle = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE SBCDetalle
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteSBCDetalle = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR SBCDetalles
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarSBCDetalles = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
